var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridViewInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1712 3.17578H14.9693C14.8104 3.17578 14.6815 3.047 14.6815 2.88804V0.78726C14.6815 0.629153 14.8104 0.499945 14.9693 0.499945H19.1712C19.3303 0.499945 19.459 0.628904 19.459 0.78726V2.88804C19.459 3.047 19.3301 3.17578 19.1712 3.17578Z",
    fill: "#919EAB",
    stroke: "#919EAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1712 7.90332H14.9693C14.8102 7.90332 14.6815 7.77436 14.6815 7.61601V5.51522C14.6815 5.35627 14.8104 5.22748 14.9693 5.22748H19.1712C19.3301 5.22748 19.459 5.35627 19.459 5.51522V7.61601C19.459 7.77411 19.3301 7.90332 19.1712 7.90332Z",
    fill: "#919EAB",
    stroke: "#919EAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1712 12.6309H14.9693C14.8106 12.6309 14.6815 12.5018 14.6815 12.3431V10.2423C14.6815 10.0836 14.8106 9.9546 14.9693 9.9546H19.1712C19.3301 9.9546 19.459 10.0834 19.459 10.2423V12.3431C19.459 12.5021 19.3301 12.6309 19.1712 12.6309Z",
    fill: "#919EAB",
    stroke: "#919EAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59167 2.88902V2.88804V0.78726C7.59167 0.628978 7.72071 0.499945 7.87899 0.499945H12.0814C12.2405 0.499945 12.3691 0.628904 12.3691 0.78726V2.88804C12.3691 3.047 12.2403 3.17578 12.0814 3.17578H7.87899C7.71907 3.17578 7.59136 3.04702 7.59167 2.88902Z",
    fill: "#919EAB",
    stroke: "#919EAB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59167 7.61698V7.61601V5.51522C7.59167 5.35609 7.72071 5.22748 7.87899 5.22748H12.0814C12.2403 5.22748 12.3691 5.35627 12.3691 5.51522V7.61601C12.3691 7.77411 12.2403 7.90332 12.0814 7.90332H7.87899C7.71889 7.90332 7.59137 7.77439 7.59167 7.61698Z",
    fill: "#919EAB",
    stroke: "#919EAB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9896 3.17578H0.787618C0.628736 3.17578 0.499878 3.047 0.499878 2.88804V0.78726C0.499878 0.629153 0.628736 0.499945 0.787618 0.499945H4.9896C5.14841 0.499945 5.27734 0.629079 5.27734 0.78726V2.88804C5.27734 3.04682 5.14824 3.17578 4.9896 3.17578Z",
    fill: "#919EAB",
    stroke: "#919EAB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9896 7.90332H0.787618C0.62856 7.90332 0.499878 7.77436 0.499878 7.61601V5.51522C0.499878 5.35627 0.628736 5.22748 0.787618 5.22748H4.9896C5.14824 5.22748 5.27734 5.35644 5.27734 5.51522V7.61601C5.27734 7.77394 5.14824 7.90332 4.9896 7.90332Z",
    fill: "#919EAB",
    stroke: "#919EAB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9896 12.6309H0.787618C0.628911 12.6309 0.499878 12.5018 0.499878 12.3431V10.2423C0.499878 10.0836 0.628911 9.9546 0.787618 9.9546H4.9896C5.14824 9.9546 5.27734 10.0836 5.27734 10.2423V12.3431C5.27734 12.5019 5.14824 12.6309 4.9896 12.6309Z",
    fill: "#919EAB",
    stroke: "#919EAB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9896 17.3574H0.787618C0.628736 17.3574 0.499878 17.2286 0.499878 17.0697V14.9689C0.499878 14.8099 0.628736 14.6812 0.787618 14.6812H4.9896C5.14824 14.6812 5.27734 14.8101 5.27734 14.9689V17.0697C5.27734 17.2282 5.14806 17.3574 4.9896 17.3574Z",
    fill: "#919EAB",
    stroke: "#919EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewInactive);
export default __webpack_public_path__ + "static/media/grid-view-inactive.173e07a9df87fe5ae04f03e2f97de621.svg";
export { ForwardRef as ReactComponent };